import { getSchemeLabel, getTemplateId, getTemplateName } from "./templatePmsUtils";

const TemplatePMSHeader = ({ templates, schemes, filters, setFilters }) => (
  <div className="mb-8 mt-3 flex flex-wrap gap-6 max-sm:hidden">
    <div className="flex w-[220px] flex-col gap-2">
      <label className="text-[14px] text-[#868686]">Template Name</label>
      <select
        value={filters.template}
        onChange={(event) => setFilters((current) => ({ ...current, template: event.target.value }))}
        className="rounded bg-neutral-100 p-2 text-[#636363] focus:outline-none"
      >
        <option value="">All</option>
        {templates.map((item) => (
          <option key={getTemplateId(item)} value={getTemplateId(item)}>
            {getTemplateName(item)}
          </option>
        ))}
      </select>
    </div>
    <div className="flex w-[220px] flex-col gap-2">
      <label className="text-[14px] text-[#868686]">PMS Scheme</label>
      <select
        value={filters.scheme}
        onChange={(event) => setFilters((current) => ({ ...current, scheme: event.target.value }))}
        className="rounded bg-neutral-100 p-2 text-[#636363] focus:outline-none"
      >
        <option value="">All</option>
        {schemes.map((item) => (
          <option key={item.id} value={item.id}>{getSchemeLabel(item)}</option>
        ))}
      </select>
    </div>
  </div>
);

export default TemplatePMSHeader;
